// --- Funzioni di validazione CAP ---
function isValidFrenchCAP(cap) {
  return /^[0-9]{5}$/.test(cap) && (
    parseInt(cap.slice(0, 2)) >= 1 &&
    parseInt(cap.slice(0, 2)) <= 98
  );
}

function isValidItalianCAP(cap) {
  return /^[0-9]{5}$/.test(cap) && (
    parseInt(cap) >= 10 &&
    parseInt(cap) <= 98168
  );
}

// --- Validazione Step 1: Brand ---
function validateStep1() {
  const selected = document.querySelectorAll('input[name="brand"]:checked');
  const error = document.getElementById("brand-error");

  if (selected.length === 0) {
    error.classList.add("visible");
    return false;
  }

  error.classList.remove("visible");

  brandsSelected = [...selected].map(cb => cb.value);

  return true;
}

// --- Validazione Step 2: Country + CAP / State ---
function validateStep2() {
  const country = document.getElementById("country").value;

  const capWrapper = document.getElementById("cap-wrapper");
  const capInput = document.getElementById("cap");
  const cap = capInput ? capInput.value.trim() : "";

  const stateWrapper = document.getElementById("state-wrapper");
  const stateInput = document.getElementById("state");
  const state = stateInput ? stateInput.value.trim() : "";

  const countryError = document.getElementById("country-error");
  const capError = document.getElementById("cap-error");

  let valid = true;

  // Country
  if (!country) {
    countryError.classList.add("visible");
    valid = false;
  } else {
    countryError.classList.remove("visible");
  }

  // CAP Francia
  if (
    capWrapper &&
    !capWrapper.classList.contains("hidden") &&
    country === "France"
  ) {
    if (!cap) {
      capError.textContent = "Please enter your postal code.";
      capError.classList.add("visible");
      valid = false;
    } else if (!isValidFrenchCAP(cap)) {
      capError.textContent = "Invalid French postal code.";
      capError.classList.add("visible");
      valid = false;
    } else {
      capError.classList.remove("visible");
    }
  }

  // CAP Italia, nel caso venga mostrato anche per l'Italia
  else if (
    capWrapper &&
    !capWrapper.classList.contains("hidden") &&
    country === "Italy"
  ) {
    if (!cap) {
      capError.textContent = "Please enter your postal code.";
      capError.classList.add("visible");
      valid = false;
    } else if (!isValidItalianCAP(cap)) {
      capError.textContent = "Invalid Italian postal code.";
      capError.classList.add("visible");
      valid = false;
    } else {
      capError.classList.remove("visible");
    }
  }

  // Stato USA
  else if (
    stateWrapper &&
    !stateWrapper.classList.contains("hidden") &&
    country === "USA"
  ) {
    if (!state) {
      capError.textContent = "Please select a state.";
      capError.classList.add("visible");
      valid = false;
    } else {
      capError.classList.remove("visible");
    }
  }

  // Nessun campo aggiuntivo necessario
  else {
    capError.classList.remove("visible");
  }

  return valid;
}

// --- Validazione Step 3: Date ---
function validateStep3() {
  const date = document.getElementById("date").value;
  const error = document.getElementById("date-error");

  if (!date) {
    error.classList.add("visible");
    return false;
  }

  error.classList.remove("visible");
  return true;
}

// --- Validazione Step 4: Time ---
function validateStep4() {
  const time = document.getElementById("time").value;
  const error = document.getElementById("time-error");

  if (!time) {
    error.classList.add("visible");
    return false;
  }

  error.classList.remove("visible");
  return true;
}

// --- Validazione Step 5: Info ---
function validateStep5() {
  const name = document.getElementById("name").value.trim();
  const store = document.getElementById("store").value.trim();
  const email = document.getElementById("email").value.trim();
  const error = document.getElementById("info-error");

  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  if (!name || !store || !email || !emailValid) {
    error.classList.add("visible");
    return false;
  }

  error.classList.remove("visible");
  return true;
}

// --- Gestione avanzamento step ---
function goToStep(step) {
  const isValid = {
    2: validateStep1,
    3: validateStep2,
    4: validateStep3,
    5: validateStep4,
    6: validateStep5
  }[step] || (() => true);

  if (!isValid()) return;

  // Mostra lo step corretto nella parte destra
  document.querySelectorAll(".wizard-main .step").forEach(section => {
    section.classList.remove("active");
  });

  const targetStep = document.getElementById(`step-${step}`);

  if (targetStep) {
    targetStep.classList.add("active");
  }

  // Aggiorna lo step attivo nella parte sinistra
  document.querySelectorAll(".wizard-step").forEach(wizardStep => {
    const wizardStepNumber = parseInt(wizardStep.dataset.step, 10);

    wizardStep.classList.toggle(
      "active",
      wizardStepNumber === step
    );
  });

  // Aggiorna brandsSelected
  if (step >= 2) {
    const selected = document.querySelectorAll(
      'input[name="brand"]:checked'
    );

    brandsSelected = [...selected].map(cb => cb.value);
  }
}

// --- Event listeners ---
document.addEventListener("DOMContentLoaded", function () {
  // Step 1: brand
  document.querySelectorAll('input[name="brand"]').forEach(input => {
    input.addEventListener("change", () => {
      const brandError = document.getElementById("brand-error");

      if (brandError) {
        brandError.classList.remove("visible");
      }
    });
  });

  // Step 2: country + CAP / State
  const countryInput = document.getElementById("country");
  const capInput = document.getElementById("cap");
  const stateInput = document.getElementById("state");

  if (countryInput) {
    countryInput.addEventListener("change", () => {
      const countryError = document.getElementById("country-error");
      const capError = document.getElementById("cap-error");

      if (countryError) {
        countryError.classList.remove("visible");
      }

      if (capError) {
        capError.classList.remove("visible");
      }
    });
  }

  if (capInput) {
    capInput.addEventListener("input", () => {
      const capError = document.getElementById("cap-error");

      if (capError) {
        capError.classList.remove("visible");
      }
    });
  }

  if (stateInput) {
    stateInput.addEventListener("change", () => {
      const capError = document.getElementById("cap-error");

      if (capError) {
        capError.classList.remove("visible");
      }
    });
  }

  // Step 3: date
  const dateInput = document.getElementById("date");

  if (dateInput) {
    dateInput.addEventListener("change", () => {
      const dateError = document.getElementById("date-error");

      if (dateError) {
        dateError.classList.remove("visible");
      }
    });
  }

  // Step 4: time
  const timeInput = document.getElementById("time");

  if (timeInput) {
    timeInput.addEventListener("change", () => {
      const timeError = document.getElementById("time-error");

      if (timeError) {
        timeError.classList.remove("visible");
      }
    });
  }

  // Step 5: info
  const nameInput = document.getElementById("name");
  const storeInput = document.getElementById("store");
  const emailInput = document.getElementById("email");
  const infoError = document.getElementById("info-error");

  [nameInput, storeInput, emailInput].forEach(field => {
    if (field) {
      field.addEventListener("input", () => {
        if (infoError) {
          infoError.classList.remove("visible");
        }
      });
    }
  });
});